module.exports = __webpack_public_path__ + "img/delivery.c5fdaefe.svg";